import { LocaleService, LocaleServiceState, SolLocales } from '../services/locale.service';
import { SolTranslation } from '../models/core/sol-translation';

export class LocaleTools {
  /**
   * Retrieve the language id for a locale id, with a fallback to English
   */
  public static toCurrentLanguageId(lss: LocaleServiceState): string {
    const locale = lss.locales.find(candidate => candidate.locale === lss.locale)!;
    return locale.languageId || SolLocales.en.languageId;
  }

  /**
   * Retrieve the correct (or fallback) translation for a given languageId
   */
  public static toCorrectTranslation(translations: SolTranslation[], languageId: string): string {
    // Correct translation?
    const textForLanguageId = translations.find(text => text.languageId === languageId);
    if (!!textForLanguageId) {
      return textForLanguageId.text;
    }

    // Fallback
    return translations.length > 0 ? translations[0].text : '';
  }

  /**
   * Translates every value of `labelKeys` (an `id → i18n-key` map) into the
   * active locale, preserving the keys. Use when a component needs to pass a
   * batch of pre-translated labels into a state's `withWidget` (or similar)
   * without rebuilding the translation map per-call.
   */
  public static translateLabels<K extends string>(
    localeService: LocaleService,
    labelKeys: Record<K, string>,
  ): Record<K, string> {
    const entries = Object.entries(labelKeys) as [K, string][];
    return entries.reduce(
      (acc, [code, key]) => {
        acc[code] = localeService.translate(key);
        return acc;
      },
      {} as Record<K, string>,
    );
  }
}
